import React, {useState} from "react";
import {List, Map} from "immutable";
import PanelGroupController from "../PanelGroupController";
import Checkbox from "../Checkbox";

const FilterPanel = (props) => {
  const [currentFilter, setCurrentFilter] = useState(props.filter);

  const onChange = (item) => {
    const filterProp = item.get(props.valueKey);

    if (props.onClick) {
      props.onClick(item);
    } else {
      defaultSetFilterInQuery(props.router, props.options, props.valueKey, filterProp);
    }
    
    setCurrentFilter(filterProp);
  }

  const checkboxes = props.options.map(x => {
    return (
      <Checkbox 
        key={x.get(props.valueKey)}
        label={x.get(props.labelKey)}
        active={props.active}
        checked={currentFilter === x.get(props.valueKey)}
        onClick={() => onChange(x)}
        />
    )
  });

  return (
    <PanelGroupController title={props.title} expanded={props.expanded}>
      {checkboxes}
    </PanelGroupController>
  );
}

function defaultSetFilterInQuery(router, options, valueKey, filterProp) {
  // Remove all filters corresponding to this panel's options
  let searchQueries = Map(router.location.query)
    .filter((bool, query) => !options.find((opt) => opt.get(valueKey) === query));
  
  // And set the selected option as true unless filterProp is empty
  if (filterProp) {
    searchQueries = searchQueries.set(filterProp, true);
  }
  
  router.push({
    pathname: router.location.pathname,
    query: searchQueries.toJS()
  });
}

FilterPanel.defaultProps = {
  active: true,
  expanded: true,
  options: List(),
  title: "Filter",
  valueKey: "id",
  labelKey: "label"
}

export default FilterPanel;